export default {
  'it': {
    'iubendaid': '43105105',
    'home': {
      'about': {
        'title': 'Chi siamo',
        'text': `Weg Fashion Group è un pool di aziende e di persone che opera nel settore tessile sui mercati internazionali.<br>
        La sua storia inizia nel 1979 in una realtà che ha saputo rinnovarsi e trasformarsi con serietà e professionalità sino ad oggi, 
        grazie ad un team di persone che continua a impegnarsi per crescere ed evolversi nel sistema moda.<br>
        `
      },
      'contact': {
        'title': 'Contatti',
        'form': {
          'name': 'Nome',
          'email': 'Email',
          'phone': 'Telefono',
          'message': 'Messaggio',

          'policy': 'Accetto i termini della <a href="#policy">privacy policy</a>',
          'marketing': 'Do il consenso per attività di marketing',
          'send': 'Invia richiesta',
          'sent': 'Messaggio inviato',
          'requiredfields': 'Compila tutti i campi',
          'error': 'Errore invio messaggio'
        }
      },
      'struttura': {
        'title': 'Struttura'
      },
      'storia': {
        'title': 'Storia del gruppo',
        'overtitle_year': 'anni',
        'seventies': {
          'year': `‘70`,
          'text': `La storia di WFG inizia del 1979: Elisabetta Spadaccini e Federico Busetto  fondano  Weg, agenzia di intermediazione 
          e buying office specializzato nella produzione di maglieria.<br>
          Per motivi legati a contatti ed amicizie verso questo paese, l’attività si sviluppa soprattutto in Francia, 
          allora come oggi, nazione protagonista del sistema moda.<br>
          `,
        },
        'eighties': {
          'year': `‘80`,
          'text': `E’ il decennio dell’internazionalizzazione e nuovi mercati si aprono per Weg, che si trasforma da buying office ad azienda 
          di consulenze e service, fornendo un servizio che partendo dalla progettazione collezione giunge fino alla consegna del prodotto finito.<br>
          In breve tempo l’azienda cresce e diventa un punto di riferimento qualificato e dinamico del Made in Italy  per una vasta clientela europea.<br>
          `,
        },
        'nineties': {
          'year': `‘90`,
          'text': `Questi anni vedono l’ingresso di nuovi giovani soci Angela Ovi, Stefano Olmi e Barbara Bonini, 
          che diventeranno i protagonisti del futuro dell’azienda.<br>
          La struttura cresce ulteriormente; WEG è in grado di far fronte alle nuove e mutate esigenze della variegata clientela internazionale.<br>
          La fine degli anni 90 coincide però con nuove e più evolute esigenze: i clienti sono fortemente stimolati dalla proposta di prodotti 
          provenienti dai “nuovi paesi” emergenti.<br>
          `,
        },

        'oo': {
          'year': `‘00`,
          'text': `Forti del know how italiano e per rispondere alle nuove esigenze del mercato, l’azienda decide di esplorare un paese 
          chiave per il futuro dell’outsourcing: la Cina.<br>
          Nasce così Container 99, che apre il proprio ‘Representative Office’ nel cuore di Shanghai.<br>
          La clientela manifesta grande interesse per le proposte che nascono con la semplice idea di creare, con materie prime nobili locali, 
          un prodotto che sembri italiano.<br>
          Nel frattempo Weg continua ad impegnarsi per mantenere pulsante il Made in Italy.<br>
          L’interazione tra queste due realtà, porta nel 2007 all’inaugurazione a Carpi della nuova sede di Weg e Container99, 
          una struttura moderna e funzionale alle nuove esigenze.<br>
          `,
        },
        'ten': {
          'year': '‘10',
          'text': `Nel 2010 Container99 si trasforma in Fashion Revolution International Ltd (REV), 
          associandosi ad un forte produttore cinese.<br> Ciò ne rafforza la competitività e lo sviluppo sui mercati internazionali.<br>
          Fashion Revolution ha attualmente sedi a Shanghai e ad Hong Kong e fabbriche a Dongguan e a Zhangjiagang.<br>
          Nel 2011 viene siglato tra WFG ed il Gruppo Hengdian, multinazionale cinese a capitale privato, un importante accordo per 
          la realizzazione di un progetto uomo total look interamente made in Italy.<br>
          Nasce così By Creations, nuovo brand cinese ispirato all’italian style e che conta oggi oltre 20 punti vendita in alcuni 
          dei piu’ prestigiosi Mall della Cina ed è presente su tutte le principali piattaforme di vendita on line del paese.<br>
          I significativi risultati raggiunti si devono al grande lavoro svolto dallo staff sino-italiano dedicato al progetto, 
          con l’apporto di Lorenzo Caramalli, giovane socio dell’attuale compagine.<br>
          Dal 2016 WFG detiene una partecipazione nel progetto By Creations.<br>
          Nel 2019 By Creations viene riconosciuta dalla più importante piattaforma di vendita online, TMall (Alibaba Group), 
          nel ruolo ufficiale di TP (Third Party) sul mercato italiano, per la proposta di prodotti Made in Italy in Cina.<br>
          `
        },
        'twenty': {
          'year': '‘20',
          'text': 'Il 2020 è stato l’anno di esordio del progetto on-line, Is coming, (www.iscoming.es) gestito interamente per quanto riguarda l’aspetto produttivo da WFG e distribuito sul mercato italiano dalla show room direzionale WEG di Milano: un successo immediato ed una crescita esponenziale nonostante la situazione generale. <br> L’avvento del Covid ha infatti colpito duramente il settore tessile abbigliamento, il nostro Gruppo ha saputo fronteggiare questa situazione di emergenza differenziando i settori di attività ed investendo sulla digitalizzazione per poter continuare le relazioni internazionali in remoto: grazie a ciò i collaboratori hanno potuto continuare il lavoro e le Aziende non interrompere la loro attività, pronte alla auspicata ripartenza.'
        }
      }
    }
    
  },
  'en': {
    'iubendaid': '41856596',
    'home': {
      'about': {
        'title': 'About us',
        'text': `Weg Fashion Group is a pool of companies and people operating in the textile industry on international markets.<br>
Its history begins in 1979 in a reality that has been able to innovate and transform itself with reliability and professionalism until today, 
thanks to a team of people who continue to work hard in order to grow and develop in the fashion system.<br>`
      },
      'contact': {
        'title': 'Contacts',
        'form': {
          'name': 'Name',
          'email': 'Email',
          'phone': 'Telephone',
          'message': 'Message',

          'policy': '<a href="#policy">privacy policy</a>',
          'marketing': 'I acknowledge to personal data treatment for email marketing purposes.',
          'send': 'Send request',
          'sent': 'Message sent',
          'requiredfields': 'Fill all the fields',
          'error': 'Error in sending the message'
        }
      },
      'struttura': {
        'title': 'Structure'
      },
      'storia': {
        'title': 'History of the group',
        'overtitle_year': 'Years',
        'seventies': {
          'year': `70<sup>'s</sup>`,
          'text': `WFG history begins in 1979: Elisabetta Spadaccini and Federico Busetto found Weg, a buying office specialized in knitwear production.<br>
For reasons related to contacts and friendships in this country, the activity develops above all in France, now as then, a leading nation of the fashion system.
<br>
          `,
        },
        'eighties': {
          'year': `80<sup>'s</sup>`,
          'text': `It is the decade of internationalization and new markets are opening for Weg that changes itself.<br> From a buying office, it becomes a consulting and service company, following all the steps from collection design to the delivery of the finished product.<br>
Rapidly, the company grows and becomes a qualified and dynamic point of reference for many European customers that want Made in Italy.
<br>
          `,
        },
        'nineties': {
          'year': `90<sup>'s</sup>`,
          'text': `These years see the entrance of new young members Angela Ovi, Stefano Olmi and Barbara Bonini, who will become the protagonists of company's future.<br>
WEG grows further: it is increasingly able to meet the new and changing needs of different international customers.<br>
The end of the 90s, however, coincides with new and highly evolved needs: customers are strongly inspired by emerging "new countries" proposals.<br>

          `,
        },

        'oo': {
          'year': `00<sup>'s</sup>`,
          'text': `Thanks to a stronger Italian know-how and to meet new market needs, the company decides to explore a key country for the future of outsourcing: China.<br>
It is in this context that Container 99 was born. It opens its own 'Representative Office' in the heart of Shanghai.<br>
The customers show great interest in the proposals that comes from the simple idea of creating a product that looks Italian, with local noble raw materials.<br>
Meanwhile Weg continues to work in order to keep Made in Italy alive.<br>
The interaction between these two realities, leads in 2007 to the opening in Carpi of the new headquarters of Weg and Container99, a modern structure, appropriate to the new needs.<br>

          `,
        },
        'ten': {
          'year': `10<sup>'s</sup>`,
          'text': `In 2010, Container 99 becomes Fashion Revolution International Ltd (REV), in association with an important Chinese factory.<br> This makes its competitiveness stronger and contributes to the development on international markets.<br>
Fashion Revolution currently has offices in Shanghai and Hong Kong and factories in Dongguan and Zhangjiagang.<br>

In 2011, an important agreement is signed between WFG and the Hengdian Group, a Chinese multinational corporation with private capital, for the realization of a total look man project, entirely Made in Italy.<br>
In this way, By Creations was born, a new Chinese brand inspired by the Italian style and that now has over 20 stores in some of the most prestigious Mall in China. It is also present on all the most important online sales platforms in the country.<br>
The significant results achieved are due to the great job carried out by the Chinese-Italian staff that works on the project, with the contribution of Lorenzo Caramalli, a young member of the present team.<br>
From 2016 WFG participates in the By Creations project.<br>
In 2019 By Creations is recognized by the most important online sales platform, TMall (Alibaba Group), in the official role of TP (Third Party) on the Italian market, for the proposal of Made in Italy products in China.<br>

          `
        },
        'twenty': {
          'year': `20<sup>'s</sup>`,
          'text': '2020 was the debut year of the on-line project, Is coming, (www.iscoming.es) with the production entirely managed by WFG and distributed on the Italian market by the WEG executive showroom in Milan: an immediate success and exponential growth despite the general situation.<br>In fact, the arrival of Covid has severely damaged the textile and clothing industry, but our Group has been able to face this emergency situation by differentiating job areas and investing in digitalization in order to continue international relationships remotely: thanks to this, collaborators have been able to work and Companies haven’t interrupted their activities, ready to hopefully start again soon.'
        }

      }
    }
  },
  'fr': {
    'iubendaid': '62574989',
    'home': {
      'about': {
        'title': 'QUI NOUS SOMMES',
        'text': `Weg Fashion Group est un pool d'entreprises et de personnes opérant dans le secteur textile sur les marchés internationaux.<br>
        Son histoire commence en 1979 dans une réalité qui a reussi se renouveler et se transformer avec sérieux et professionnalisme jusqu’à ce jour, grâce à une équipe de personnes qui continuent de s'engager pour grandir et évoluer dans le système de la mode.`
      },
      'contact': {
        'title': 'Contacts',
        'form': {
          'name': 'Nom et prénom',
          'email': 'Email',
          'phone': 'Teléphone',
          'message': 'Demande',

          'policy': 'J\'accepte la politique sur le traitement des <a href="#policy">données personnelles</a>',
          'marketing': 'Je consens au traitement de mes données personnelles pour email marketing',
          'send': 'Envoyer',
          'sent': 'Message sent',
          'requiredfields': 'Fill all the fields',
          'error': 'Error in sending the message'
        }
      },
      'struttura': {
        'title': 'Structure'
      },
      'storia': {
        'title': 'Histoire du groupe',
        'overtitle_year': 'Annes',
        'seventies': {
          'year': `70<sup>'s</sup>`,
          'text': `L'histoire de WFG commence en 1979 : Elisabetta Spadaccini et Federico Busetto fondent Weg, une société de courtage et buying office spécialisée dans la production de tricot.<br>
          Pour des raisons liées aux contacts et aux amitiés avec ce pays, l'entreprise s'est surtout développée en France, alors comme aujourd'hui, nation leader dans le système de la mode.
          `,
        },
        'eighties': {
          'year': `80<sup>'s</sup>`,
          'text': `C'est la décennie de l'internationalisation et de nouveaux marchés s'ouvrent pour Weg, qui se transforme d'un buying office en une société de conseil et service, offrant un service qui commence par le design de la collection et se termine par la livraison du produit fini.<br>
          En peu de temps, l'entreprise s'est développée et est devenue une référence qualifiée et dynamique pour le Made in Italy pour une large clientèle européenne.
          `,
        },
        'nineties': {
          'year': `90<sup>'s</sup>`,
          'text': `Ces années voient l'arrivée de nouveaux jeunes partenaires Angela Ovi, Stefano Olmi et Barbara Bonini, qui deviendront les protagonistes de l'avenir de l'entreprise.<br>
          La structure se développe davantage; WEG peut répondre aux nouveaux et changés besoins de la clientèle internationale diversifiée.<br>
          La fin des années 90 coïncide cependant avec des besoins nouveaux et plus évolués : les clients sont fortement encouragés par la proposition de produits en provenance de « nouveaux pays » émergents.
          `,
        },

        'oo': {
          'year': `00<sup>'s</sup>`,
          'text': `Merci au savoir-faire italien et pour répondre aux nouveaux besoins du marché, la société décide d'explorer un pays clé pour l'avenir de l'outsourcing : la Chine.<br>
          C'est ainsi que Container 99es t né et il a ouvert son propre « Representative Office » au cœur de Shanghai.<br>
          Les clients montrent un grand intérêt pour les propositions qui se présentent avec l'idée simple de créer, avec des matières premières nobles locales, un produit qui paraît italien.<br>
          Entre-temps, Weg continue de s'engager pour garder le Made in Italy très vif.<br>
          L'interaction entre ces deux réalités a conduit en 2007 à l'inauguration à Carpi du nouveau siège de Weg et Container99, une structure moderne et fonctionnelle pour répondre aux nouveaux besoins.
          `,
        },
        'ten': {
          'year': `10<sup>'s</sup>`,
          'text': `En 2010, Container99 devient Fashion Revolution International Ltd (REV), en s'associant à un producteur chinois très fort.<br>
          Cela renforce sa compétitivité et son développement sur les marchés internationaux.<br>
          Fashion Revolution a actuellement des bureaux à Shanghai et Hong Kong et des usines à Dongguan et Zhangjiagang.<br>
          En 2011, un accord important a été signé entre WFG et Hengdian Group, une multinationale chinoise à capital privé, pour la réalisation d'un projet de total look masculin totalement made in Italy.<br>
          Ainsi By Creations est née, une nouvelle marque chinoise inspirée du style italien et qui compte aujourd'hui plus de 20 boutiques dans des Malls les plus prestigieux de Chine et elle est présente sur toutes les principales plateformes de vente on line du pays.<br>
          Les résultats significatifs obtenus sont dus à l'excellent travail effectué par le staff sino-italien dédié au projet, avec la contribution de Lorenzo Caramalli, un jeune partenaire de l'équipe actuelle.<br>
          Depuis 2016, WFG participe au projet By Creations.<br>
          En 2019, By Creations est reconnu par la plus importante plateforme de vente on line, TMall (Groupe Alibaba), dans le rôle officiel de TP (Third Party) sur le marché italien, pour la proposition de produits Made in Italy en Chine.
          `
        },
        'twenty': {
          'year': `20<sup>'s</sup>`,
          'text': `2020 a été la première année du projet on line Iscoming (www.iscoming.es) entièrement géré, en ce qui concerne l'aspect production, par WFG et distribué sur le marché italien par le showroom directionnel WEG à Milan : un succès immédiat et une exponentielle croissance malgré la situation générale.<br>
          L’arrivée du Covid a en effet durement touché le secteur textile de vêtements, notre Groupe a reussi à faire face à cette situation d'urgence en différenciant les secteurs d'activité et en investissant dans la digitalisation afin de poursuivre les relations internationales à distance : grâce à cela, les collaborateurs ont pu continuer le travail et les entreprises n'ont pas interrompu leurs activités, prêtes pour le nouveau commencement souhaité.`
        }

      }
    }
  }
}
